"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToast = useToast;
exports.PrimeVueToastSymbol = void 0;

var _vue = require("vue");

var PrimeVueToastSymbol = Symbol();
exports.PrimeVueToastSymbol = PrimeVueToastSymbol;

function useToast() {
  var PrimeVueToast = (0, _vue.inject)(PrimeVueToastSymbol);

  if (!PrimeVueToast) {
    throw new Error('No PrimeVue Toast provided!');
  }

  return PrimeVueToast;
}
